import React from 'react'

export default function Text() {
  return (
    <>
      <h1>Text Styling</h1>
      <p>There are several classes that can be used to easily add styling to text </p>
    
      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="thin"&gt;Thin&lt;/p&gt;<br/>
            &lt;p class="medium"&gt;Medium&lt;/p&gt;<br/>
            &lt;p class="bold"&gt;Bold&lt;/p&gt;<br/>
            &lt;p class="boldest"&gt;Boldest&lt;/p&gt;<br/>
            &lt;p class="italic"&gt;Italic&lt;/p&gt;<br/>
            &lt;p class="underline"&gt;Underline&lt;/p&gt;<br/>
            &lt;p class="strike"&gt;Strike&lt;/p&gt;<br/>
            &lt;p class="text-left"&gt;Text-Left&lt;/p&gt;<br/>
            &lt;p class="text-center"&gt;Text-Center&lt;/p&gt;<br/>
            &lt;p class="text-right"&gt;Text-Right&lt;/p&gt;<br/>
            &lt;p class="text-justify"&gt;Text-Justify&lt;/p&gt;<br/>
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve'>
        <p className="thin">Thin</p>
        <p className="medium">Medium</p>
        <p className="bold">Bold</p>
        <p className="boldest">Boldest</p>
        <p className="italic">Italic</p>
        <p className="underline">Underline</p>
        <p className="strike">Strike</p>
        <p className="text-left">Text-Left</p>
        <p className="text-center">Text-Center</p>
        <p className="text-right">Text-Right</p>
        <p className="text-justify">Text-Justify</p>
      </div>
    </>
  )
}
